import { TonConnectUI } from '@tonconnect/ui';
import { TONCONNECT_MANIFEST_URL } from '~/config';

export default {
    install(Vue) {
        // eslint-disable-next-line no-param-reassign
        Vue.prototype.$tonConnect = new TonConnectUI({
            manifestUrl: TONCONNECT_MANIFEST_URL,
        });
    },
};
